import { Loader, ResetPassword } from '@tfo/common'
import * as React from 'react'
import RootStore from '../../stores/RootStore'
import { useIntl } from 'react-intl'
import { Elements } from '@tfo/common'
import './CreatePassword.scss'
import * as queryString from 'query-string'
import { makeStyles } from '@material-ui/core'
import { useStore } from '../../hooks'
import { useLocation } from 'react-router-dom'
import { observer } from 'mobx-react'

const { Heading4, InputErrorMessage } = Elements
export interface ICreatePassword {
	rootStore?: RootStore
}

const CreatePassword = observer(() => {
	const intl = useIntl();
	const rootStore = useStore();
	const location = useLocation();

	const changePassword = async (data: any) => {
		rootStore.createPasswordController.onCreatePassword(
			queryString.parse(location.search), data.newPassword
		)
	}

	const useStyles = makeStyles({
		input: {
			fontFamily: 'Arial',
			fontSize: '1.6rem',
			letterSpacing: '0.001rem',
			lineHeight: '2.8rem',
			color: '#3D3D3C',
			background: '#ffffff',
			border: '1px solid #dfdfde',
			position: 'relative',
			padding: '1.7rem 2.4rem',
			width: '100%',
			margin: 0,
			opacity: 1,
			zIndex: 0,
			'& .MuiInput-underline:before, & .MuiInput-underline:after, & .MuiInput-underline:hover:not(.Mui-disabled):before': {
				borderBottom: 'none',
			},
			'.MuiTextField-root:focus': {
				borderColor: '#0098c3',
				zIndex: 2,
			},
		},
		inputPassword: {
			width: '100%',
			padding: '0.6rem 0.6rem',
			borderRadius: '0',
			backgroundColor: '#FFFFFF'

		},
		button: {
			width: '100%',
			height: '64px',
			backgroundColor: '#009B48',
			fontWeight: 'bold',
			color: '#ffffff',
			fontStyle: 'normal',
			fontFamily: 'Arial, sans-serif',
			textTransform: 'none',
			fontSize: '1.6rem',
			borderRadius: 0,
			'&:hover': {
				backgroundColor: '#48C865',
			},
		},
		label: {
			marginBottom: '10px',
		},
		passwordValidations: {
			display: 'flex',
			flexDirection: 'row',
			alignItems: 'center',
			margin: 'auto',
			marginLeft: '30px',
			width: '55%',
			height: '24px',

		},
		passwordValidationsGrid: {
			margin: 'auto',
			width: '350px',
			borderRadius: '12px',
			marginBottom: '12px'
		},
		passwordRepeatErrorText: {
			textAlign: 'left',
			color: '#F50057',
			fontWeight: 'bold',
			letterSpacing: '0.4px'
		},
	})

	return (
		<div className="CreatePassword">
			<div className="CreatePasswordHeader">
				<Heading4>
					{intl.formatMessage({ id: 'common.createPassword' })}
				</Heading4>
			</div>

			<ResetPassword
				showOldPassword={false}
				apiMethod={changePassword}
				useStyles={useStyles}
				hasLabels={true} />

			{rootStore.createPasswordController.tokenError && (
				<InputErrorMessage>
					{intl.formatMessage({ id: 'errormessage.create-password-token' })}
				</InputErrorMessage>
			)}
			
			{rootStore.createPasswordController.loading && <Loader />}
		</div>
	)
})

export default CreatePassword